import { NgModule, Optional, SkipSelf } from '@angular/core';

// import { SharedModule } from '../shared/shared.module';
import { MenuService } from './menu/menu.service';
import { PagetitleService } from './pagetitle/pagetitle.service';
import { TranslatorService } from './translator/translator.service';
import { ColorsService } from './colors/colors.service';

import { throwIfAlreadyLoaded } from './module-import-guard';
import {AuthService} from '../services/auth.service';

@NgModule({
    imports: [
        // SharedModule
    ],
    providers: [
        MenuService,
        PagetitleService,
        TranslatorService,
        ColorsService,
        AuthService
    ]
})
export class CoreModule {
    constructor( @Optional() @SkipSelf() parentModule: CoreModule) {
        throwIfAlreadyLoaded(parentModule, 'CoreModule');
    }
}



// WEBPACK FOOTER //
// /home/alinu/Alin/Work/Workspace/BART-client/src/app/core/core.module.ts